var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"c-page-title",class:_vm.classCase},[_c('en',{attrs:{"s":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }